import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AppShell from "./components/AppShell";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Invoices from "./pages/Invoices";
import Clients from "./pages/Clients";
import Expenses from "./pages/Expenses";
import Income from "./pages/Income";
import GST from "./pages/GST";
import IncomeTax from "./pages/IncomeTax";
import AIAssistant from "./pages/AIAssistant";
import Settings from "./pages/Settings";
import Import from "./pages/Import";

function Shell({ children }) {
  return (
    <ProtectedRoute>
      <AppShell>{children}</AppShell>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            <Route path="/app" element={<Navigate to="/app/dashboard" replace />} />
            <Route path="/app/dashboard" element={<Shell><Dashboard /></Shell>} />
            <Route path="/app/invoices" element={<Shell><Invoices /></Shell>} />
            <Route path="/app/clients" element={<Shell><Clients /></Shell>} />
            <Route path="/app/expenses" element={<Shell><Expenses /></Shell>} />
            <Route path="/app/income" element={<Shell><Income /></Shell>} />
            <Route path="/app/gst" element={<Shell><GST /></Shell>} />
            <Route path="/app/tax" element={<Shell><IncomeTax /></Shell>} />
            <Route path="/app/ai" element={<Shell><AIAssistant /></Shell>} />
            <Route path="/app/import" element={<Shell><Import /></Shell>} />
            <Route path="/app/settings" element={<Shell><Settings /></Shell>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
